import { Component, Inject, OnInit } from '@angular/core';
import { Account, AccountResource } from '@apaq/orgkit-js';
import { ContextService, Roles } from 'ngx-orgkit';
import { DialogRef } from 'src/app/modules/dialog/dialog-ref';
import { DATA, DIALOG } from 'src/app/modules/dialog/dialog.service';

@Component({
  selector: 'app-security-editor',
  templateUrl: './security-editor.component.html',
  styleUrls: ['./security-editor.component.scss']
})
export class SecurityEditorComponent implements OnInit {

  constructor(@Inject(DIALOG) private dialog: DialogRef, 
    @Inject(DATA) public account: Account, 
    private context: ContextService,
    private accountResource: AccountResource) { }

  _role: 'ADMIN' | 'MANAGEMENT' | 'USER' | 'EMPLOYEE' = 'ADMIN';
  changed = false;

  ngOnInit(): void {
    this.updateLoggedInUserRole();
  }

  isLoggedInUserAdmin() {
    const roles = this.context.account?.roles ?? [];
    return Roles.hasPermissionsForOrganization(roles, this.context.organizationId!, 'ADMIN');
  }

  isAccountLoggedInUser() {
    return this.context.account.id === this.account.id;
  }

  get role() {
    return this._role;
  }

  set role(role: 'ADMIN' | 'MANAGEMENT' | 'USER' | 'EMPLOYEE') {
    this._role = role;
    this.changed = true;
    this.accountResource.setOrganizationRoles(this.account.id, [role]). then(result => {
      this.account = result;
      this.updateLoggedInUserRole();
    });
  }

  async remove() {
    if(await Stallion.confirm($localize`Are you sure you want to remove ${this.account.name} from your organization?`, 'danger', undefined, $localize`Yes, remove ${this.account.name}`)) {
      await this.accountResource.delete(this.account);
      this.dialog.close('changed');
    }
  }

  close() {
    this.dialog.close(this.changed ? 'changed' : undefined);
  }

  private updateLoggedInUserRole() {
    const roles = Roles.getPermissionsForOrganization(this.account?.roles ?? [], this.context.organizationId!);
    if(roles.includes('ADMIN')) {
      this._role = 'ADMIN';
      return;
    }

    if(roles.includes('MANAGEMENT')) {
      this._role = 'MANAGEMENT';
      return;
    }

    if(roles.includes('USER')) {
      this._role = 'USER';
      return;
    }

    this._role = 'EMPLOYEE';
    
  }
}
